import React from 'react';
import './App.scss';

const baseUrl = './images/'

function App() {

  const year = new Date().getFullYear() || '2021';

  return (
    <div className="App">

      {/* header */}
      <div className="header">
        <div className="content">
          <div className="logo_paopao" onClick={() => (window.location.reload())}></div>
          <div className="tab">
            <div className="tab_item">首页</div>
          </div>
          <div className="logo_game" onClick={() => (window.location.href = 'http://game.163.com/')}></div>
          <div className="logo_dashen" onClick={() => (window.location.href = 'https://ds.163.com/')}></div>
        </div>
      </div>

      {/* banner */}
      <div className="banner">
        <div className="banner_img img"></div>
        {/* <img src={require(`${baseUrl}banner.png`)} className="banner_img" alt={''} /> */}
      </div>

      {/* content */}
      <div className="game_content">
        <div className="wrap">
          <div className="label">  热门游戏  </div>
          <div className="game_wrap">

            {
              data.map(({ title, detail, image, jumpUrl }) => (
                <div className="game_card" onClick={() => (window.location.href = jumpUrl)} key={title}>
                  <img src={require(`${baseUrl + image}`)} className="card_image" alt={''} />
                  <div className="content_wrap">
                    <div className="content_title">{title}</div>
                    <div className="content_detail">{detail}</div>
                    <div className="content_jump">进入官网</div>
                  </div>
                </div>

              ))
            }

          </div>
        </div>
      </div>


      {/* footer */}
      <div className="nie-copyright-new-inner">
        <div className="nie-cn-part1">
          <span className="nie-cn-logo">
            <a className="a0" href="http://www.163.com" target="_blank" rel="noopener noreferrer" >
              <img src={require(`${baseUrl}netease.2.png`)} alt={''} />
            </a>
            <a className="a1" href="http://game.163.com" target="_blank" rel="noopener noreferrer" >
              <img src={require(`${baseUrl}nie.2.png`)} alt={''} />
            </a>
          </span>
          <span className="nie-cn-nav">
            <i className="nie-cn-nav-i1">
              <a href="http://gb.corp.163.com/gb/about/overview.html" target="_blank" rel="noopener noreferrer" >公司简介</a> - <a href="http://help.163.com/" target="_blank" rel="noopener noreferrer" >客户服务</a> - <a href="http://gb.corp.163.com/gb/legal.html" target="_blank" rel="noopener noreferrer" >网易集团隐私政策及儿童个人信息保护规则</a> - <a href="http://game.163.com/about/" target="_blank" rel="noopener noreferrer" >网易游戏</a> - <a href="http://game.163.com/contact/" target="_blank" rel="noopener noreferrer" >联系我们</a> - <a href="http://game.163.com/contact/business.html" target="_blank" rel="noopener noreferrer" >商务合作</a> - <a href="http://hr.game.163.com/index.html" target="_blank" rel="noopener noreferrer" >加入我们</a>
            </i>
            <br />
            <i className="nie-cn-nav-i2">
              {`网易公司版权所有 ©1997-${year}`}
            </i>
          </span>
        </div>
        <div className="nie-cn-part2"><a href="http://www.beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" >ICP备案：粤B2-20090191-18</a> </div>
      </div>



    </div>
  );
}


const data = [
  {
    title: '《百闻牌》',
    detail: '不负盛名，夜映群星！5月9日百闻牌主播赛耀世开战，敬请期待！',
    image: 'game1.png',
    jumpUrl: 'https://ssr.163.com',
  },
  {
    title: '《我的世界》',
    detail: '五一佳节，《我的世界》专属特色的“搬砖节”应运而生！',
    image: 'game2.png',
    jumpUrl: 'http://mc.163.com',
  },
  {
    title: '《第五人格》',
    detail: '“暖樱与汤泉之夜”限时开启，全新浴衣时装活动免费获取，更有海量福利！',
    image: 'game3.png',
    jumpUrl: 'http://id5.163.com/index.html',
  },
  {
    title: '《海岛纪元》',
    detail: '踏上奇幻岛屿，修建属于你的家园岛，与萌宠并肩，开展丰富多变的元素战斗！',
    image: 'game4.png',
    jumpUrl: 'https://hd.163.com/fab/',
  },

  {
    title: '《猎魂觉醒》',
    detail: '《猎魂觉醒》烬灭之炎兽潮S6开启，五一收获汗水勋章',
    image: 'game5.png',
    jumpUrl: 'http://lh.163.com/fab/',
  },
  {
    title: '《大话西游》手游',
    detail: '全新玩法修罗斗技场即将开启！自由配置，对战决胜！胜者通吃装备，全民公平',
    image: 'game6.png',
    jumpUrl: 'http://dhxy.163.com',
  },
  {
    title: '《率土之滨》',
    detail: '在这个三国乱世，每一寸土地都可争夺，每一个抉择都可能改变战局！',
    image: 'game7.png',
    jumpUrl: 'http://stzb.163.com',
  },
  {
    title: '《倩女幽魂》手游',
    detail: '广寒宫、九重天神仙美景，邀三界少侠共同游览！蒲家村秋千玩法再升级，春光明',
    image: 'game8.png',
    jumpUrl: 'http://qnm.163.com/index.html',
  },

]


export default App;
